import React from 'react';
import { Dialog } from '@mui/material';
import cn from 'classnames';
// own
import { createSx } from '../../../../utils';
import { useAttachmentsStateContext } from '../../provider/AttachmentsStateProvider';
import { KEY_NAME } from '../../../../../submodules/web-shared/enums/key-name';
import { NAVBAR_WIDTH_OFFSET, HEADER_HEIGHT_OFFSET } from '../../../../../frontend/simpl2/modules/RedesignedShipmentManager/components/ShipmentOverviewPopover/components/shared/AttachmentPopup/consts';
import { useCustomMediaQuery } from '../../../../../submodules/web-shared/hooks/mediaQuery';
import DialogContent from './components/DialogContent';
import { mobileViewStyle } from './style';

const sx = createSx({
  paper: {
    width: `calc(100vw - ${NAVBAR_WIDTH_OFFSET}px)`,
    maxWidth: `calc(100vw - ${NAVBAR_WIDTH_OFFSET}px)`,
    maxHeight: `calc(100vh - ${HEADER_HEIGHT_OFFSET}px)`,
    height: `calc(100vh - ${HEADER_HEIGHT_OFFSET}px)`,
    mx: `${NAVBAR_WIDTH_OFFSET}px`,
    my: `${HEADER_HEIGHT_OFFSET}px`,
    boxShadow: 'none',
    borderRadius: 1,
    display: 'flex',
    flexDirection: 'row',
    '&.isMobileView': {
      ...mobileViewStyle
    }
  },
});

interface Props {
  AttachmentDetails?: React.ElementType;
}

export const AttachmentPopup = ({ AttachmentDetails }: Props) => {
  const { clearActiveAttachment, activeAttachmentNode } = useAttachmentsStateContext();
  const isMobileView = useCustomMediaQuery('down', 'lg');

  const handleDialogClose = () => clearActiveAttachment();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === KEY_NAME.ESC) handleDialogClose();
  };

  return (
    <Dialog
      slotProps={{
        paper: { sx: sx.paper, className: cn({ isMobileView }) }
      }}
      className={cn({ isMobileView })}
      onClose={handleDialogClose}
      open={!!activeAttachmentNode}
      data-test-id='attachment-details-modal'
      onKeyDown={handleKeyDown}
      disableEnforceFocus
    >
      {activeAttachmentNode &&
        <DialogContent
          activeAttachment={activeAttachmentNode.value}
          handleClose={handleDialogClose}
          AttachmentDetails={AttachmentDetails}
        />
      }
    </Dialog>
  );
};

export default AttachmentPopup;